module.exports = "\n <img src=\"../../assets/img/model.jpg\" id=\"bg\" alt=\"\">\n\t\t\t <div class=\"loginmodal-container\">\n\t\t\t\t\t\n\t\t\t\t\t<h1>Service Advisor\t</h1><br>\n\t\t\t\t \n\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"username\" placeholder=\"Username\" maxlength=\"20\" />\n\t\t\t\t\t<input type=\"password\" [(ngModel)]=\"password\" placeholder=\"Password\" maxlength=\"20\"/>\n\t\t\t\t\t<input type=\"submit\" class=\"login loginmodal-submit\" value=\"Login\"(click)=\"login();\">\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t  \n\t\t\t\t</div> \n\t\t\t"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main